<app-selector label="Sjt Game" [isEmptySelectable]="isEmptySelectable" [data]="sjtGameCoreService.sjtGameList$| async" displayKey="name" [formControl]="ctrl"
    (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="sjtGameCoreService.loading" [hint]="hint">
</app-selector>